import { forwardRef } from 'react';

import { FormControlLabel, FormControlLabelProps } from '@mui/material';

import { mergeSx, tokens } from '@cast/design-system';

type CardFormControlProps = FormControlLabelProps;

export const CardFormControl = forwardRef<
  HTMLLabelElement,
  CardFormControlProps
>(({ sx, ...props }, ref) => {
  return (
    <FormControlLabel
      ref={ref}
      {...props}
      disableTypography
      sx={mergeSx(
        {
          p: 12,
          mx: 0,
          width: '100%',
          alignItems: 'center',
          columnGap: 8,
          borderRadius: '4px',
          borderStyle: 'solid',
          borderWidth: 1,
          borderColor: tokens.theme.border.structural.neutral,
          backgroundColor: tokens.theme.bg.structural.surface,
          color: tokens.theme.fg.structural.primary,
          '&:hover': {
            backgroundColor: tokens.theme.bg.structural.surface,
            borderColor: tokens.theme.border.action.neutralHover,
          },
          ':has(.Mui-checked)': {
            borderColor: tokens.theme.border.selection.primary,
            backgroundColor: tokens.theme.bg.structural.surface,
            color: tokens.theme.fg.structural.primary,
            '&:hover': {
              backgroundColor: tokens.theme.bg.structural.surface,
              borderColor: tokens.theme.border.selection.primary,
            },
          },
          // Disabled overrides selected — applies to selected and unselected
          ':has(.Mui-disabled), &.Mui-disabled': {
            borderColor: tokens.theme.disabled.border,
            backgroundColor: tokens.theme.bg.structural.surface,
            color: tokens.theme.disabled.fg,
            '&:hover': {
              backgroundColor: tokens.theme.bg.structural.surface,
              borderColor: tokens.theme.disabled.border,
            },
            '& .MuiTypography-root': {
              color: tokens.theme.disabled.fg,
            },
          },
        },
        sx
      )}
    />
  );
});

CardFormControl.displayName = 'CardFormControl';
